import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { Segment, Grid, Icon } from 'semantic-ui-react';
import moment from 'moment';

import { isEmpty, map, get } from '../../utils/lodash';
import { EmptyContainer } from '../../components';
import { ViewNotification } from '../organization/forms';

class RecentActivitiesSegment extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      notifications: null,
      page: 1,
    };
  }

  handlePaginationChange(activePage) {
    const { getNotificationsAll } = this.props;
    activePage = activePage + 1;
    this.setState(
      {
        page: activePage,
      },

      () => {
        getNotificationsAll(activePage);
      }
    );
  }

  async deleteNotification(id) {
    const { deleteUserNotification } = this.props;
    await deleteUserNotification(id);
  }

  render() {
    const {
      userNotificationsAll = {},
      loading,
      updateNotificationReadStatus,
      i18n,
      t,
    } = this.props;
    const { page = 1 } = this.state;

    return (
      <>
        <Segment
          className="content-segment-dashboard-recent-activity"
          loading={loading}
        >
          {isEmpty(userNotificationsAll.docs) ? (
            <EmptyContainer
              msg={t('dashboard.recent_activities_no_notification_found')}
            />
          ) : (
            <Segment.Group className="recent-activity-segments">
              {map(userNotificationsAll.docs, (item, i) => {
                const senderName = `${get(
                  item,
                  'notification.sender.firstName',
                  ''
                )} ${get(item, 'notification.sender.surname', '')}`;
                return (
                  <Segment
                    key={i}
                    className={`notify-info-custom clickable ${
                      item.isRead ? '' : 'ui-segment-custom'
                    }`}
                  >
                    {' '}
                    <ViewNotification
                      records={item}
                      trigger={
                        <Grid.Column mobile={14} tablet={11} computer={10}>
                          <div className="notify-info-main">
                            <div className="notify-info-main-icon-wrap">
                              {!item.isRead && (
                                <Icon
                                  name="circle"
                                  size="tiny"
                                  color="blue"
                                  className="notify-info-main-icon"
                                />
                              )}
                            </div>
                            <div>
                              <label className="notify-info">
                                <strong className="Body-Large-Semibold">
                                  {senderName}:
                                </strong>{' '}
                                {get(item, 'notification.title', '-')}{' '}
                              </label>
                              <br></br>
                              <label className="recent-activity-date">
                                {new Intl.DateTimeFormat(i18n.language, {
                                  day: '2-digit', // DD
                                  month: 'short', // MMM
                                  year: 'numeric', // YYYY
                                  hour: '2-digit', // hh
                                  minute: '2-digit', // mm
                                  hour12: true, // a (am/pm)
                                }).format(new Date(item.createdAt))}
                              </label>
                            </div>
                          </div>
                        </Grid.Column>
                      }
                      updateNotificationReadStatus={(id) =>
                        updateNotificationReadStatus(id, true)
                      }
                    />
                    {item.isRead && (
                      <Grid.Column mobile={2} tablet={5} computer={6}>
                        <div className="dashboard-notification">
                          <Icon
                            circular
                            name="close"
                            size="small"
                            className="notify-dashboard-main-icon"
                            onClick={() => this.deleteNotification(item.id)}
                          />
                          {/*  */}
                        </div>
                      </Grid.Column>
                    )}
                  </Segment>
                );
              })}
              {page >= userNotificationsAll.pages ? null : (
                <Segment className="see-more-todo">
                  <div
                    className="see-more-todo-text"
                    onClick={() => this.handlePaginationChange(page)}
                  >
                    {t('toggle.see_more')}
                  </div>
                </Segment>
              )}
            </Segment.Group>
          )}
        </Segment>
      </>
    );
  }
}
RecentActivitiesSegment = withTranslation()(RecentActivitiesSegment);
export default RecentActivitiesSegment;
